document.addEventListener('DOMContentLoaded', function (event) {
  document.body.classList.remove('gradient-bg')

  let tabLinks
  let tabs

  tabLinks = document.getElementsByClassName('offices-tabs--links')[0].children
  tabs = document.getElementsByClassName('tabs')

  const tabLink1 = tabLinks && tabLinks[0]
  const tabLink2 = tabLinks && tabLinks[1]

  const tab1 = tabs && tabs[0]
  const tab2 = tabs && tabs[1]

  tabLink1 && tabLink1.addEventListener('click', function () {
    tab1.style.display = 'block'
    tab2.style.display = 'none'

    if (!tabLink1.classList.contains('active')) {
      tabLink1.classList.add('active')
      tabLink2.classList.remove('active')
    }
    $('.slideshow-slick').slick('refresh')
  })

  tabLink2 && tabLink2.addEventListener('click', function () {
    tab2.style.display = 'block'
    tab1.style.display = 'none'

    if (!tabLink2.classList.contains('active')) {
      tabLink2.classList.add('active')
      tabLink1.classList.remove('active')
    }
    $('.slideshow-slick').slick('refresh')
  })

  // Adding 'typography-h5' to all heading in the privat office_contact
  const infoItem = document.getElementsByClassName('info-item')

  for (item of infoItem) {
    const headings = item.querySelectorAll('h1, h2, h3, h4, h5, h6')
    for (head of headings) {
      head.classList.add('typography-h5')
    }

    const pTags = item.querySelectorAll('p')
    for (p of pTags) {
      if (p.innerText) {
        p.classList.add('no-empty-p')
      }
    }
  }
})
